import styled, { css } from "styled-components";


export const StyledImageEditToolbar = styled.div`
  position: absolute;

  display: flex;
  gap: 0.5rem;
  width: ${({ underEditImageData }) => (!underEditImageData ? "auto" : "100%")};
  ${({ containerShape, isInPopUp }) => {
    if(isInPopUp){
        return css`
            top: 0;
            right: 0;
            transform: translateY(-100%);
        `
    }
    //else it is not in popup
    return containerShape === "circle"
      ? css`
          top: 7%;
          right: 4%;
          /* transform: translate(50%, -50%); */
        `
      : css`
          top: 0;
            right: 0;
        `}
  }
`;


export const StyledFullWidthImgWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  
`

export const StyledImg = styled.img`
  /* z-index: -1; */
  position: absolute;
  left: 0;
  top: 0;
  transform: ${({cropX = 0, cropY = 0 }) => `translate(${cropX}%,${cropY}%)` };
  margin-left: ${({marginLeft = 0}) =>  marginLeft}; //when image is 'contain'ed
  margin-top: ${({marginTop = 0}) =>  marginTop}; //when image is 'contain'ed
  ${({fullWidthOrFullHeightImg, imageSpread}) => {
    if(fullWidthOrFullHeightImg === 'fullWidth'){
      return imageSpread === 'cover'
        ? `width: 100%; height: auto;`
        : `
            height: 100%; 
            width: auto;
            left: 50%;
            transform: translateX(-50%);
          ` //contain
    }
    else if(fullWidthOrFullHeightImg === 'fullHeight'){
      return imageSpread === 'cover'
        ? `height: 100%; width: auto;`
        : `
            width: 100%; 
            height: auto;
            top: 50%;
            transform: translateY(-50%);
          `
    }
  }}
`;

export const StyledImageWrapper = styled.div`
  position: relative;
  height: 100%;
  border: 2px solid ${( {theme} )=> theme?.colors?.primaryColor10};
`;